import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class GoalBarPopOut extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: unknown
    ): IterableIterator<number> {
        const renderable = gameObject.getComponent(Renderable);
        const element = gameObject.getComponent(ElementComponent);

        renderable.visible = true;

        element.anchorTopLeft.set(0, 0.5);
        element.anchorBottomRight.set(0, 0.5);

        const moveUpTweenTopLeft     = this.getTween(element.anchorTopLeft);
        const moveUpTweenBottomRight = this.getTween(element.anchorBottomRight);

        moveUpTweenTopLeft.to({ x: 0, y: 2 }, 500).easing(Easing.Back.In);
        moveUpTweenBottomRight.to({ x: 0, y: 2 }, 500).easing(Easing.Back.In);

        yield* AwaitIterators([
            this.startTween(moveUpTweenTopLeft),
            this.startTween(moveUpTweenBottomRight),
        ]);
        renderable.visible = false;
    }
}
